import { render, staticRenderFns } from "./GlobalTopics.vue?vue&type=template&id=4ddcaeee&"
import script from "./GlobalTopics.vue?vue&type=script&lang=ts&"
export * from "./GlobalTopics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports